import React from 'react'
import './SupportScreen.css'

function SupportScreen () {
    return (
        <div className='privacy'>
                <h1>Soporte de Ahavá</h1>
                <h3 className="h3">Nos alegra mucho que te contactes con nosotros</h3>
                <h5 className="h5">Estas vías de comunicación están abiertas y disponibles a todos los Usuarios de la Plataforma que tengan una inquietud, queja, sugerencia, comentario o reporte para mejorar la Plataforma y el Servicio que ofrecemos a todos nuestros Usuarios. Estas son las vías de comunicación:</h5>

                <h5 className="h5">- Número telefónico: 55 2556 4336, en los que se le atenderá a la brevedad posible. Con horario de atención de lunes a viernes de 7:00 a.m. (Hora del Centro de México) a 9:00 p.m. (Hora del Centro de México). Sábados y Domingos de 8:00 a.m. (Hora del Centro de México) a 2:00 p.m.</h5>

                <h5 className="h5">- Whatsapp: De igual forma podemos atenderle, mediante Whatsapp, ya sea mandándonos un mensaje o llamando a través de la aplicación. Los números telefónicos de atención al cliente son los siguientes 229 162 2239 o 55 2556 4336, en los que se le atenderá a la brevedad posible. Con horario de atención de lunes a viernes de 7:00 a.m. (Hora del Centro de México) a 9:00 p.m. (Hora del Centro de México). Sábados y Domingos de 8:00 a.m. (Hora del Centro de México) a 2:00 p.m. (Hora del Centro de México).</h5>

                <h5 className="h5">- Correo electrónico: soporte@ahava.one (Tiempo de respuesta: 48 horas hábiles)</h5>
        </div>
    )
}

export default SupportScreen
